import logdown from 'logdown';
try {
    window.localStorage.debug = 'layout2019';
}
catch (e) {
}
var Logger = logdown('layout2019');
Logger.state.isEnabled = true;
if (process.env.NODE_ENV === 'production') {
    Logger.info = function () { };
    Logger.debug = function () { };
    Logger.log = function () { };
    Logger.warn = function () { };
}
export { Logger };
